import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { TEST_CONST } from 'src/app/constants/constants';
import { StateManagementService } from 'src/app/services/state-management.service';

export const testActivateGuard: CanActivateFn = (route, state) => {
  const stateManagementService = inject(StateManagementService);
  const router = inject(Router);

  if (
    (state.url === '/' || state.url === '/detail') &&
    stateManagementService.isCandidateFormAllowed
  ) {
    return true;
  } else if (
    state.url === '/test' &&
    stateManagementService.isTestRouteAllowed &&
    sessionStorage.getItem(TEST_CONST.auth_token)
  ) {
    return true;
  } else if (
    state.url === '/submit-test' &&
    stateManagementService.isSubmitTestRouteAllowed
  ) {
    return true;
  } else {
    return router.createUrlTree(['/verify/test_code']);
  }
};
